(function ($) {
  DJ.addBehavior('videoModal', '.btn--open-video', {
    attach: function () {
      const videoButton = this;
      const $body = $(document.body);
      const $cemsSlider = $(videoButton).closest('.cems-slider');
      const videoUrl = videoButton.getAttribute('data-video-url');
      const videoModalTpl = document.createElement('div');
      const videoModalClose = document.createElement('button');

      videoModalClose.classList.add('video-modal__close');
      videoModalTpl.classList.add('video-modal');

      /**
       * Build video iframe
       */
      const buildVideoIframe = (id) => {
        videoModalTpl.innerHTML = `
          <div class="video-modal__wrapper">
            <iframe
              src="https://player.vimeo.com/video/${id}"
              frameborder="0"
              autoplay="0"
              allow="fullscreen"
              allowfullscreen
              >
            </iframe>
          </div>`;

        $(videoModalTpl.querySelector('.video-modal__wrapper')).append(videoModalClose);
      };

      /**
       * get Vimeo video id using Vimeo API
       */
      const getVimeoIDbyUrl = (url) => {
        let id = false;
        const request = new XMLHttpRequest();

        request.open('GET', `https://vimeo.com/api/oembed.json?url=${url}`);

        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            const response = JSON.parse(request.responseText);
            if (response.video_id) {
              id = response.video_id;

              buildVideoIframe(id);
            }
          } else {
            buildVideoIframe();
          }
        };

        request.send();

        return id;
      };

      getVimeoIDbyUrl(videoUrl);

      /**
       * Close video modal.
       * If the modal was opened from a slider - slider autoplay starts.
       */
      const onClose = () => {
        videoModalTpl.classList.remove('video-modal--opened');
        document.getElementsByTagName('html')[0].classList.remove('html--locked');
        $body.off('click.bodyCloseVideoModal');
        $(document).off('keydown.escCloseVideoModal');

        if ($cemsSlider) {
          $cemsSlider.slick('slickPlay');
        }

        const bodyTimer = setTimeout(() => {
          $(videoModalTpl).remove();
          clearTimeout(bodyTimer);
        }, 500);
      };

      /**
       * Close video modal on body click.
       */
      const onBodyClick = () => {
        $body.on('click.bodyCloseVideoModal', (e) => {
          if (!($(e.target).closest('.video-modal__wrapper iframe').length)) {
            onClose();
          }
        });
      };

      /**
       * Close video modal on esc key press.
       */
      const onEscKeyPress = () => {
        $(document).on('keydown.escCloseVideoModal', (e) => {
          if (e.code === 'Escape') {
            onClose();
          }
        });
      };

      /**
       * Open video modal by click on a button.
       * If the modal was opened from a slider - slider autoplay stops.
       * HTML and body are locked(not possible to scroll) while the modal is opened.
       */
      videoButton.addEventListener('click', (e) => {
        e.preventDefault();

        $(document.body).append(videoModalTpl);

        if ($cemsSlider) {
          $cemsSlider.slick('slickPause');
        }

        document.getElementsByTagName('html')[0].classList.add('html--locked');
        const bodyTimer = setTimeout(() => {
          videoModalTpl.classList.add('video-modal--opened');
          onBodyClick();
          onEscKeyPress();
          clearTimeout(bodyTimer);
        }, 50);
      });

      /**
       * Close video modal on a close button click.
       */
      videoModalClose.addEventListener('click', () => {
        onClose();
      });
    }
  });
})(jQuery);
